export function getErrorMessage(error) {
  const data = error?.response?.data

  if (typeof data?.message === 'string') {
    return data.message
  }

  return ''
}

export function isResourceAccessDenied(error) {
  const status = error?.response?.status
  const message = getErrorMessage(error).toLowerCase()

  if (status === 401) {
    return true
  }

  if (status === 403) {
    if (message.includes('no tiene permisos suficiente') ||
      message.includes('no pertenece')) {
      return true
    }

    // Blob responses hide JSON message; skipGlobal403Logout marks resource-scoped requests.
    if (error.config?.skipGlobal403Logout) {
      return true
    }
  }

  return false
}
